import { FC } from 'react';

import { TaskType } from '__generated__/GQL';
import * as Form from 'components/_core/form';

import locales from './locales';

type Option = { label: string; value: TaskType };

const TYPE_OPTIONS: Option[] = [
  { label: locales[TaskType.Product], value: TaskType.Product },
  { label: locales[TaskType.Service], value: TaskType.Service },
];

interface TaskTypeSelectProps
  extends Omit<Form.SunshineSelectProps<Option>, 'value'> {
  value: TaskType | null;
}

const TaskTypeSelect: FC<TaskTypeSelectProps> = ({ value, ...props }) => (
  <Form.SunshineSelect
    {...props}
    options={TYPE_OPTIONS}
    value={TYPE_OPTIONS.find((option) => option.value === value)}
  />
);

export default TaskTypeSelect;
